<script setup lang="ts">
import { Beat } from '../models/Beats';
import TodaysLogCard from './TodaysLogCard.vue';
import EmptyCard from './EmptyCard.vue';
import { useUnsavedChanges } from '@/composables/useUnsavedChanges';
import { useLock } from '@/composables/useLock';

defineProps<{
	beats: Beat[];
}>();

const emit = defineEmits<{
	(e: 'beatEdited'): void;
}>();

const {
	lock,
	unlock,
	isLockReason,
	isLocked,
	onLockChange,
} = useLock();

const { toggle } = useUnsavedChanges();

onLockChange(toggle);
</script>

<template>
	<div class="mt-5 z-0">
		<div>
			<TransitionGroup
				v-if="beats.length > 0"
				name="card"
				tag="ul"
				class="grid grid-cols-cards gap-8 transition-all duration-300 ease-in-out"
			>
				<TodaysLogCard
					v-for="(beat, $index) in beats"
					:key="beat.beatId"
					:beat="beat"
					:style="`z-index: ${20 - $index}`"
					:editable="!isLocked || isLockReason(beat.beatId)"
					@editing:start="lock(beat.beatId)"
					@editing:end="unlock"
					@editing:success="emit('beatEdited')"
				/>
			</TransitionGroup>
			<EmptyCard
				v-else
			>
				{{ $t('dashboard.emptyCard') }}
			</EmptyCard>
		</div>
	</div>
</template>
